import { render } from "./Buy.vue?vue&type=template&id=4ef59753"
import script from "./Buy.vue?vue&type=script&lang=ts"
export * from "./Buy.vue?vue&type=script&lang=ts"
script.render = render

export default script